<div *ngIf="selectedImageValues">
    <mat-dialog-title style="position: relative;">
        <p style="text-align: center; font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
        margin-left: -24px;margin-right: -24px;">
            <span *ngIf="selectedImageType==='S'">Settled Details</span>
            <span *ngIf="selectedImageType==='D'">Deleted Details</span>
            <span *ngIf="selectedImageType==='R'">Waiting For Deletion Details</span>
    
        </p>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onNoClick()"
        style="color: black; top: -5px;left: 740px;position: absolute;">
            <span aria-hidden="true" class="">&times;</span>
        </button>
    </mat-dialog-title>
    <div class="ka-em-update-modal-content" style="padding-left: 17px;"
        *ngIf="selectedImageValues && selectedImageType==='S'">
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Bride Details</div>
                    <div class="col-md-8">
                        <p class="ka-em-settle-label">
                            {{selectedImageValues['brideProfileID']}}
                            <span>{{selectedImageValues['brideName']}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Bride Owner</div>
                    <div class="col-md-8">
                        <p>{{selectedImageValues['brideOwner']}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Groom Details</div>
                    <div class="col-md-8">
                        <p class="ka-em-settle-label">
                            {{selectedImageValues['groomProfileID']}}
                            <span>{{selectedImageValues['groomName']}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Groom Owner</div>
                    <div class="col-md-8">
                        <p>{{selectedImageValues['GroomOwner']}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Settled Date</div>
                    <div class="col-md-8">
                        <p>{{selectedImageValues['settledDate']}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Entered By</div>
                    <div class="col-md-8">
                        <p>{{selectedImageValues['settletedby']}}</p>

                    </div>
                </div>
            </div>

        </div>
        <div class="row" style="padding-left: 15px;">
            <p>{{selectedImageValues['settlenotes']}}</p>
        </div>
    </div>
    <div class="ka-em-update-modal-content" style="padding-left: 17px;"
        *ngIf="selectedImageValues && selectedImageType==='D'">
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">ProfileID: </div>
                    <div class="col-md-8">
                        <p class="">
                            {{selectedImageValues['ProfileID']}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Deleted By: </div>
                    <div class="col-md-8">
                        <p> {{selectedImageValues['DeleteBy']}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Deleted Date: </div>
                    <div class="col-md-8">
                        <p class="ka-em-settle-label">

                            <span> {{selectedImageValues['DeletedDate']}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">

            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-3 ka-em-delete-label">Reason for Deletion: </div>
                    <div class="col-md-9">
                        <p class="ka-em-settle-label">

                            <span> {{selectedImageValues['deletenotes']}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ka-em-update-modal-content" style="padding-left: 17px;"
        *ngIf="selectedImageValues && selectedImageType==='R'">
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">ProfileID: </div>
                    <div class="col-md-8">
                        <p class="">
                            {{selectedImageValues['ProfileID']}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Deleted Date: </div>
                    <div class="col-md-8">
                        <p class="ka-em-settle-label">

                            <span> {{selectedImageValues['DeletedDate']}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Deleted By: </div>
                    <div class="col-md-8">
                        <p> {{selectedImageValues['DeleteBy']}}</p>
                    </div>
                </div>
            </div> -->
        </div>
        <!-- <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-4 ka-em-settled-label">Deleted Date: </div>
                    <div class="col-md-8">
                        <p class="ka-em-settle-label">

                            <span> {{selectedImageValues['DeletedDate']}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">

            </div>
        </div> -->
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-3 ka-em-delete-label">Reason for Deletion: </div>
                    <div class="col-md-9">
                        <p class="ka-em-settle-label">

                            <span> {{selectedImageValues['deletenotes']}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<div *ngIf="duplicateModalData">
    <mat-dialog-title style="position: relative;">
        <p style="text-align: center; font-weight: bold; background-color: #efefef; color: #c89d07;padding: 16px;margin-top: -8px;
        margin-left: -24px;margin-right: -24px;">
            <span *ngIf="selectedImageType==='I'">Inactive Details</span>
            <span *ngIf="selectedImageType==='M'">MMSerious Details</span>
    
        </p>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="onNoClick()" style="color: black; top: 0px;left: 740px;position: absolute;">
            <span aria-hidden="true" class="">&times;</span>
        </button>
    </mat-dialog-title>
    <mat-dialog-content>
        <div *ngIf="duplicateModalData">
            <app-grid [data]="duplicateModalData" [defaultColumns]="duplicateModalHeaders" [grid2]="grid2Type"
                [matchedHeaders]="duplicateModalMatchedHeaders">
            </app-grid>
        </div>
    </mat-dialog-content>

</div>